/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_UlovdomovInputs */

const cs_enum_ulovdomov = /** @type {(inputs: Enum_UlovdomovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UlovDomov`)
};

const en_enum_ulovdomov = /** @type {(inputs: Enum_UlovdomovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UlovDomov`)
};

/**
* | output |
* | --- |
* | "UlovDomov" |
*
* @param {Enum_UlovdomovInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_ulovdomov = /** @type {((inputs?: Enum_UlovdomovInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_UlovdomovInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_ulovdomov(inputs)
	return cs_enum_ulovdomov(inputs)
});